// extracted by mini-css-extract-plugin
export var tabContainer = "circleTabs-module--tabContainer--L0OwI";
export var tab = "circleTabs-module--tab--F6ppN";
export var active = "circleTabs-module--active--LKY2m";
export var tabContentContainer = "circleTabs-module--tabContentContainer--TmvqD";
export var tabContent = "circleTabs-module--tabContent--u0YZU";
export var fadeIn = "circleTabs-module--fadeIn--uwAic";
export var slideIn = "circleTabs-module--slideIn--da-YG";